import { DialogM } from "@common/components/alert/dialog/Dialog"
import { apiIdle } from "@data/redux/actions/api"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

export function useApiStatus(
    serviceName,
    successMessage = "",
    errorMessage = true,
    successCallback = () => {},
    errorCallback = () => {},
    noIdle = false
) {
    const serviceApiSelector = useSelector(
        (state) => state.api?.[serviceName?.name]
    )
    const dispatch = useDispatch()

    useEffect(() => {
        if (serviceApiSelector?.success) {
            if (!noIdle) {
                dispatch(apiIdle(serviceName))
            }
            if (successMessage)
                DialogM.show({
                    text1: "Succès",
                    text2: successMessage,
                })
            successCallback(
                serviceApiSelector?.data,
                serviceApiSelector?.all_data,
                serviceApiSelector?.urlParams,
                serviceApiSelector?.routeParams
            )
        }

        // if there is no message, it means that there was no response data, and the request was intercepted by the global interceptor in _layout.js
        if (serviceApiSelector?.error?.message) {
            // 409 `needs_confirmation` and 422 `requires_force` errors are
            // owned by the caller's errorCallback — skip the generic dialog
            // so the caller can prompt its own confirmation flow. Same for a
            // 422 `claim_rejected_reason`: its message explains a refused
            // request, not an error, and the caller renders it itself.
            const needsConfirmation = serviceApiSelector?.error?.needs_confirmation
            const requiresForce = serviceApiSelector?.error?.requires_force
            const claimRejected = serviceApiSelector?.error?.claim_rejected_reason
            if (errorMessage && !needsConfirmation && !requiresForce && !claimRejected) {
                let errorMessages = []

                if (serviceApiSelector?.error?.errors) {
                    errorMessages = Object.keys(
                        serviceApiSelector?.error?.errors
                    )?.map((key) => serviceApiSelector?.error?.errors[key][0])
                }

                DialogM.show({
                    text1: "Erreur",
                    text2:
                        serviceApiSelector?.error?.message +
                        (errorMessages ? "\n" + errorMessages.join("\n") : ""),
                })
                dispatch(apiIdle(serviceName))
            }
            errorCallback(
                serviceApiSelector?.error,
                serviceApiSelector?.urlParams,
                serviceApiSelector?.routeParams
            )
        }
    }, [serviceApiSelector?.success, serviceApiSelector?.error])
}
